import React from 'react'

const NotFound = () => {
    console.error('not found ');
    return (
        <div>NotFound</div>
    )
}

export default NotFound